import { useEffect, useState } from "react";
import Button from "../components/Misc/Button";
import LeftRightContentText from "../components/LeftRightContentText";
import { useAppContext } from "../_context";
import ImageLeftFooter from "../components/Footer/ImageLeftFooter";
import Hero from "../components/Pages/About/Hero";
import TimelineSection from "../components/Pages/About/TimelineSection";
import Employees from "../components/Pages/About/Employees";
import Founders from "../components/Pages/About/Founders";
import Contentful from "../utilities/Contentful";
import { getLinkToContentfulMedia } from "../utilities/Helpers";
import moment from "moment";
import Head from "next/head";

const About = () => {
  const [{ tx }] = useAppContext();
  const [employees, setEmployees] = useState([]);
  const [timelineItems, setTimelineItems] = useState([]);

  useEffect(() => {
    async function getEmployees() {
      const results = await new Contentful().fetch({
        content_type: "employee",
        order: "fields.name",
      });
      setEmployees([...results]);
    }

    async function getTimelineItems() {
      const results = await new Contentful().fetchValueOnly({
        content_type: "timeline",
        order: "fields.date",
      });
      const dates = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];

      setTimelineItems(
        results.map((item) => {
          const parsed = moment(item.date);
          return {
            date: `${tx[dates[parsed.month()]]} ${parsed.year()}`,
            content: tx[item.event] || item.event,
            icon: getLinkToContentfulMedia(item, "icon"),
          };
        }),
      );
    }

    getEmployees();
    getTimelineItems();
  }, []);

  return (
    <>
      <Head>
        <title>RacketPal - {tx["About"]}</title>
      </Head>
      <Hero />
      <LeftRightContentText
        title={tx["The RacketPal story"]}
        className="section-padding-top"
        centeredTitle={true}>
        <p className="text-black">
          {
            tx[
              "We've all been there,  you really fancy a game of tennis (or badminton, squash, table tennis, padel) but you have nobody to play with. Your friends are down the pub or sitting at home on the sofa, not interested in hitting the court. That’s exactly the problem RacketPal founders Robert and Bogdan realised they shared. And that’s where the RacketPal story began..."
            ]
          }
        </p>
        <p className="text-black">
          {
            tx[
              "As two passionate tennis and squash players, Robert and Bogdan realised there was no obvious way for them to meet other players who were also up for a game. But they knew there had to be a way to fix that. And it all started one evening in September 2018..."
            ]
          }
        </p>
        <p className="text-black">
          {
            tx[
              "The pair were enjoying a pint in The Cleveland Arms in Paddington when it happened. The eureka moment struck and they decided it was time to create an app to help racket sports players meet each other. The very next day they started working on plans for the app."
            ]
          }
        </p>
        <p className="mb-0 text-black">
          {
            tx[
              "Now, from what was once an idea down the pub, is a thriving community of tens of thousands of players and growing team of passionate sports lovers, all determined to create one of the biggest online sports communities in the world."
            ]
          }
        </p>
      </LeftRightContentText>
      <TimelineSection data={timelineItems} nEmployees={employees.length} />
      <Founders />
      <Employees employees={employees} />
      <ImageLeftFooter image="/img/footers/careers.jpg" light={true}>
        <h2>{tx["Come join us"]}</h2>
        <p>
          {
            tx[
              "Here at RacketPal we embrace the modern way of working. We don’t demand you come to an office. Or commit to a rigid schedule. What we ask is that you bring passion, enthusiasm and a desire to make RacketPal better than when you joined. If that sounds like you, we’d love to hear from you."
            ]
          }
        </p>
        <Button href="/careers">{tx["See current opportunities"]}</Button>
      </ImageLeftFooter>
    </>
  );
};

export default About;
